import { View } from "../_core/components";
import React from "react";
import { useConfig } from "../_util/use-config";
export function FormDivider() {
    var classPrefix = useConfig().classPrefix;
    return React.createElement(View, { className: classPrefix + "-form-divider" });
}
//# sourceMappingURL=FormDivider.js.map